import SectionHead from "./SectionHead";

const PRINCIPLES = [
  { icon: "ri-eye-line", title: "先分清事实与观点", desc: "哪句是官方确认的事实，哪句是网友猜测，都尽量标得清清楚楚，不让你被带偏节奏。" },
  { icon: "ri-file-list-3-line", title: "尽量给出来源与出处", desc: "关键信息附上可追溯的出处与说明，你随时可以去原始信息里自行核实。" },
  { icon: "ri-refresh-line", title: "错了就认、发现就改", desc: "信息一直在流动，复盘也不是一次成型。一旦有新的公开信息，会第一时间更正补全。" },
  { icon: "ri-heart-3-line", title: "不拱火、不引战", desc: "复盘的目的是把事讲清楚，而不是放大对立。理性表达、和而不同，才是健康的吃瓜方式。" },
];

const PRAISES = [
  {
    text: "本来完全没跟上，看了一遍时间线就全懂了，终于能接上群里的话。",
    who: "追到一半的瓜友",
  },
  {
    text: "把事实和网友脑补分得这么清楚，这点很加分，不会越看越糊涂。",
    who: "长期读者",
  },
  {
    text: "大结局复盘那块说得特别明白，还留了彩蛋分析，值得收藏慢慢看。",
    who: "补课新手",
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="page-shell">
        <SectionHead
          kicker="关于 88吃瓜"
          title="我们为什么做这份复盘"
          desc="热点来得快去得也快，真正难的是把事情看完整。我们想做的，就是在一地碎片里，帮你把一条线拼清楚。"
        />

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-2">
          {/* principles */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {PRINCIPLES.map((p) => (
              <div
                key={p.title}
                className="rounded-2xl border border-background-200 bg-background-100/70 p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-100 text-xl text-accent-700">
                  <i className={p.icon} aria-hidden="true" />
                </span>
                <h3 className="mt-3 text-sm font-black text-foreground-950 md:text-base">{p.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{p.desc}</p>
              </div>
            ))}
          </div>

          {/* praises */}
          <div className="flex flex-col rounded-2xl border border-background-200 bg-background-100/70 p-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-foreground-950">一路以来，大家的反馈</h3>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-lg text-background-50">
                <i className="ri-double-quotes-l" aria-hidden="true" />
              </span>
            </div>
            <ul className="mt-4 flex-1 space-y-3">
              {PRAISES.map((p) => (
                <li key={p.who} className="rounded-xl bg-background-50 px-4 py-3">
                  <p className="text-sm leading-relaxed text-foreground-800">“{p.text}”</p>
                  <p className="mt-1.5 text-xs font-semibold text-primary-500">— {p.who}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* invite + disclaimer */}
        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="flex flex-col justify-between gap-4 rounded-2xl border border-primary-200 bg-primary-100/50 p-6 sm:flex-row sm:items-center">
            <div>
              <h3 className="text-base font-black text-primary-700">想看某个瓜的完整复盘？</h3>
              <p className="mt-1 text-sm text-foreground-800">
                或者发现内容有出入想提醒我们？发邮件给编辑部，我们会认真对待每一条反馈。
              </p>
            </div>
            <a
              href="mailto:editor@88chigua.example"
              className="inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line" aria-hidden="true" />
              给编辑部留言
            </a>
          </div>

          <aside className="rounded-2xl border border-background-200 bg-background-100/70 p-6">
            <h3 className="flex items-center gap-2 text-sm font-black text-foreground-950">
              <i className="ri-information-line text-primary-500" aria-hidden="true" />
              内容说明
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              本站内容为公开信息与网友讨论的整理汇总，仅供娱乐参考，不构成对任何事件的事实认定，也不代表任何第三方立场。涉及人物与机构的信息请以官方渠道为准。反馈邮箱：
              editor@88chigua.example
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}